import {View,map} from "vritra";


export default function ProduceList(props){
    const producelist=View({...props,tag:"ul"});

    producelist.innateHTML=`
        ${map(produce,({name})=>`
            <li>${name}</li>
        `)}
    `;

    return producelist;
}

const produce=[
    {name:"pear",type:"fruit"},
    {name:"potato",type:"vegetable"},
    {name:"pineapple",type:"fruit"},
    {name:"cabbage",type:"vegetable"},
    {name:"raspberry",type:"fruit"},
    {name:"peas",type:"vegetable"},
];
